import { GET_ALL_ORDERS, GET_APPROVER_ORDERS, GET_ORDER_DETAILS, LOGOUT, SET_ORDER_STATUS, SET_SHIPPING_STATUS, UPLOAD_LABEL_ZIP, RESEND_PENDING_EMAIL } from '../actions.type'
import { SET_ORDERS, SET_ORDER_DETAILS } from '../mutations.type'
import OrderService from '@/services/OrderService'
import moment from 'moment'
import router from '../../router'


const state = {
  orders: [],
  orderData: {},
  orderDetails: ''
}

const getters = {
  orders: state => state.orders.map(id => state.orderData[id]),
  orderDetails: state => state.orderDetails
}

const actions = {
  [GET_ALL_ORDERS]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      OrderService.getOrders()
        .then(response => {
          if (response.data) {
            if (response.data.error) {
              reject(response.data.error)
            } else if (response.data.data) {
              commit(SET_ORDERS, response.data.data)
              resolve()
            } else {
              reject('NO DATA')
            }
          } else {
            reject('NO RESPONSE')
          }
        })
        .catch(err => {
          if (err && err.response && err.response.status === 403) {
            commit(LOGOUT);
            router.replace('/login');
          }
          reject(err)
        })
    })
  },
  [GET_APPROVER_ORDERS]: ({ commit }, userId) => {
    return new Promise((resolve, reject) => {
      OrderService.getApproverOrders(userId)
        .then(response => {
          if (response.data) {
            if (response.data.error) {
              reject(response.data.error)
            } else if (response.data.data) {
              commit(SET_ORDERS, response.data.data)
              resolve()
            } else {
              reject('NO DATA')
            }
          } else {
            reject('NO RESPONSE')
          }
        })
        .catch(err => {
          if (err && err.response && err.response.status === 403) {
            commit(LOGOUT);
            router.replace('/login');
          }
          reject(err)
        })
    })
  },
  [GET_ORDER_DETAILS]: ({ commit }, orderNumber) => {
    return new Promise((resolve, reject) => {
      OrderService.getOrderDetails(orderNumber)
        .then(response => {
          if (response.data) {
            if (response.data.error) {
              reject(response.data.error)
            } else if (response.data.data) {
              commit(SET_ORDER_DETAILS, response.data.data)
              resolve()
            } else {
              reject('NO DATA')
            }
          } else {
            reject('NO RESPONSE')
          }
        })
        .catch(err => {
          if (err && err.response && err.response.status === 403) {
            commit(LOGOUT);
            router.replace('/login');
          }
          router.replace('/');
          reject(err)
        })
    })
  },
  [SET_ORDER_STATUS]: ({ commit }, { orderId, status, revisedMessage, tooManyItems, tooCloseToEvent, stillNeeded, additionalComments }) => {
    return new Promise((resolve, reject) => {
      OrderService.setOrderStatus(orderId, status, revisedMessage, tooManyItems, tooCloseToEvent, stillNeeded, additionalComments)
        .then(response => {
          if (response.data) {
            if (response.data.error) {
              reject(response.data.error)
            } else if (response.data.data) {
              resolve()
            } else {
              reject('NO DATA')
            }
          } else {
            reject('NO RESPONSE')
          }
        })
        .catch(err => {
          if (err && err.response && err.response.status === 403) {
            commit(LOGOUT);
            this.$router.replace('/login');
          }
          reject(err)
        })
    })
  },
  [SET_SHIPPING_STATUS]: ({ commit, dispatch }, { orderId, status, trackingNumbers, fileName, file }) => {
    return new Promise((resolve, reject) => {
      OrderService.setShippingStatus(orderId, status, trackingNumbers, fileName)
        .then(response => {
          if (response.data) {
            if (response.data.error) {
              reject(response.data.error)
            } else if (response.data.data) {
              if(response.data.data.url){
                let url = response.data.data.url
              dispatch(UPLOAD_LABEL_ZIP, {url, file})
              resolve()
              }
              resolve()
            } else {
              reject('NO DATA')
            }
          } else {
            reject('NO RESPONSE')
          }
        })
        .catch(err => {
          if (err && err.response && err.response.status === 403) {
            commit(LOGOUT);
            this.$router.replace('/login');
          }
          reject(err)
        })
    })
  },
  [UPLOAD_LABEL_ZIP]: ({ commit }, { url, file }) => {
    return new Promise((resolve, reject) => {
      OrderService.uploadLabelZip(url, file)
        .catch(err => {
          if (err && err.response && err.response.status === 403) {
            console.log(err);
          }
          reject(err)
        })
    })
  },
  [RESEND_PENDING_EMAIL]: ({ commit }, {email, orderId}) => {
    return new Promise((resolve, reject) => {
      OrderService.resendPendingEmail(email, orderId)
      .then( resolve())
        .catch(err => {
          if(err && err.response && err.response.status === 403) {
            commit(LOGOUT);
            this.$router.replace('/login');
          }
          reject(err)
        })
    })
  }
}

// basic mutations, showing loading, success, error to reflect the api call status and the token when loaded
const mutations = {
  [SET_ORDERS]: (state, data) => {
    state.orderData = {}
    data.forEach(order => {
      state.orderData[order.id] = order

      if(order.to_date && order.from_date){
        order.event_date = moment(order.from_date).format('MM/DD/YY') + "-" + moment(order.to_date).format('MM/DD/YY');
      }
    });
    state.orders = Object.keys(state.orderData)
  },
  [SET_ORDER_DETAILS]: (state, data) => {
    if (data.billing && data.shipping) {
      const k1 = data.billing
      const k2 = data.shipping

      if (JSON.stringify(k1) === JSON.stringify(k2)) {
        data.match = true
      }
      else {
        data.match = false;
      }
    }
    else {
      data.match = false;
    }
    if (data.order_items) {
      data.quantity = 0;
      if(data.delivery_date){
        data.delivery_date = moment(data.delivery_date).format('MM/DD/YYYY');
      }
      data.order_items.forEach(items => {
        if (items.quantity) {
          data.quantity += items.quantity
          items.total = items.price * items.quantity;
        }
        if (items.to_date) {
          items.to_date = moment(items.to_date).format('MM/DD/YYYY');
        }
        if(items.from_date) {
          items.from_date = moment(items.from_date).format('MM/DD/YYYY');
        }
      })
    }
    state.orderDetails = data;
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
